var map = {
	"./AIChatBot/aichatbot.module": [
		"./src/app/pages/desktop/AIChatBot/aichatbot.module.ts",
		"default~AIChatBot-aichatbot-module~RCS-rcs-module~SMS-sms-module~USER-user-module",
		"default~AIChatBot-aichatbot-module~RCS-rcs-module~SMS-sms-module",
		"AIChatBot-aichatbot-module"
	],
	"./RCS/rcs.module": [
		"./src/app/pages/desktop/RCS/rcs.module.ts",
		"default~AIChatBot-aichatbot-module~RCS-rcs-module~SMS-sms-module~USER-user-module",
		"default~AIChatBot-aichatbot-module~RCS-rcs-module~SMS-sms-module",
		"default~RCS-rcs-module~SMS-sms-module",
		"RCS-rcs-module"
	],
	"./SMS/sms.module": [
		"./src/app/pages/desktop/SMS/sms.module.ts",
		"default~AIChatBot-aichatbot-module~RCS-rcs-module~SMS-sms-module~USER-user-module",
		"default~AIChatBot-aichatbot-module~RCS-rcs-module~SMS-sms-module",
		"default~SMS-sms-module~pages-desktop-desktop-module",
		"default~RCS-rcs-module~SMS-sms-module",
		"SMS-sms-module"
	],
	"./USER/user.module": [
		"./src/app/pages/desktop/USER/user.module.ts",
		"default~AIChatBot-aichatbot-module~RCS-rcs-module~SMS-sms-module~USER-user-module",
		"USER-user-module"
	],
	"./pages/desktop/desktop.module": [
		"./src/app/pages/desktop/desktop.module.ts",
		"default~SMS-sms-module~pages-desktop-desktop-module",
		"pages-desktop-desktop-module"
	],
	"./pages/login/login.module": [
		"./src/app/pages/login/login.module.ts",
		"pages-login-login-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;